import { __ } from '@wordpress/i18n';
import {
	InspectorControls,
	MediaUpload,
	RichText,
} from '@wordpress/block-editor';
import { useState } from '@wordpress/element';
import {
	PanelBody,
	Button,
	TextControl,
	SelectControl,
} from '@wordpress/components';

export default function Edit( { attributes, setAttributes } ) {
	const {
		accordionQuestion,
		accordionAnswer,
		accordionAnswerType,
		accordionAudioAnswer,
		accordionVideoAnswer,
	} = attributes;

	const [ openIndex, setOpenIndex ] = useState( -1 );

	const handleToggle = ( index ) => {
		setOpenIndex( openIndex === index ? -1 : index );
	};

	const onChangeAccordionQuestion = ( newText ) => {
		setAttributes( { accordionQuestion: newText } );
	};
	const onChangeAccordionAnswer = ( newText ) => {
		setAttributes( { accordionAnswer: newText } );
	};
	const onChangeAccordionAnswerType = ( newText ) => {
		setAttributes( { accordionAnswerType: newText } );
	};
	// upload  //
	const onSelectAudioMediaChange = ( media ) => {
		setAttributes( {
			accordionAudioAnswer: media.url,
		} );
	};
	const onSelectVideoMediaChange = ( media ) => {
		setAttributes( {
			accordionVideoAnswer: media.url,
		} );
	};

	const accordionAnswerTypeOptions = [
		{ value: 'text', label: __( 'Text', 'ask-faq' ) },
		{ value: 'audio', label: __( 'Audio', 'ask-faq' ) },
		{ value: 'video', label: __( 'Video', 'ask-faq' ) },
	];

	const faqData = [
		{
			question: 'Add Question',
			answer: 'Accordion. An accordion is used to show (and hide) HTML content. Use the w3-hide class to hide the accordion content. An accordion is a design element that expands in place to expose some hidden information. Unlike overlays, accordions push the page content down instead ofbeing superposed on top of page content.',
		},
	];
	return (
		<>
			<InspectorControls>
				<PanelBody>
				<SelectControl
						label={ __( 'Type of Write Answer', 'ask-faq' ) }
						value={ accordionAnswerType }
						options={ accordionAnswerTypeOptions.map(
							( { value, label } ) => ( {
								value,
								label,
							} )
						) }
						onChange={ onChangeAccordionAnswerType }
						help={ __(
							'Choose the type of answer you wanna show',
							'ask-faq'
						) }
					/>
					<TextControl
						label={ __( 'Write Question', 'ask-faq' ) }
						value={ accordionQuestion }
						onChange={ ( val ) =>
							setAttributes( { accordionQuestion: val } )
						}
						placeholder={ __( 'Write Question', 'ask-faq' ) }
						help={ __(
							'Write your question to show as Write Question.',
							'ask-faq'
						) }
					/>
					
					{ accordionAnswerType === 'text' && (
						<TextControl
							label={ __( 'Write Answer', 'ask-faq' ) }
							value={ accordionAnswer }
							onChange={ ( val ) =>
								setAttributes( { accordionAnswer: val } )
							}
							placeholder={ __( 'Write Answer', 'ask-faq' ) }
							help={ __(
								'Write your answer to show as Write Answer.',
								'ask-faq'
							) }
						/>
					) }
					{ accordionAnswerType === 'audio' && (
						<MediaUpload
						onSelect={
							onSelectAudioMediaChange
						}
						allowedTypes={ [ 'audio' ] }
						render={ ( { open } ) => (
							<Button
								onClick={ open }
								style={ {
									fontSize: '16px',
								} }
							>
								<span className="dashicons dashicons-cloud-upload"></span>{ ' ' }
								{ __(
									'Upload Audio',
									'ta-askfaq'
								) }
							</Button>
						) }
					/>
					) }
					{ accordionAnswerType === 'video' && (
							<MediaUpload
							onSelect={
								onSelectVideoMediaChange
							}
							allowedTypes={ [ 'video' ] }
							render={ ( { open } ) => (
								<Button
									onClick={ open }
									style={ {
										fontSize: '16px',
									} }
								>
									<span className="dashicons dashicons-cloud-upload"></span>{ ' ' }
									{ __(
										'Upload Video',
										'ta-askfaq'
									) }
								</Button>
							) }
						/>
					) }
				</PanelBody>
			</InspectorControls>
			{ faqData.map( ( faq, index ) => (
				<li
					className={ `ask__single__accordion faq-item ${
						index === openIndex ? 'ask__active' : ''
					}` }
					key={ index }
				>
					<div
						className={ `ask__accordion ask-faq ${
							index === openIndex ? 'ask__active' : ''
						}` }
						onClick={ () => handleToggle( index ) }
					>
						<RichText
							onChange={ onChangeAccordionQuestion }
							className="title"
							value={ accordionQuestion }
							placeholder={ __(
								'Write Question',
								'ask-faq'
							) }
							tagName="span"
							allowedFormats={ [] }
						/>
						<div>
							<span className="ask__closed__icon">
								<svg
									width="15"
									height="15"
									xmlns="http://www.w3.org/2000/svg"
									viewBox="0 0 512 512"
								>
									<path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z" />
								</svg>
							</span>
							<span className="ask__open__icon">
								<svg
									width="15"
									height="15"
									xmlns="http://www.w3.org/2000/svg"
									viewBox="0 0 512 512"
								>
									<path d="M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z" />
								</svg>
							</span>
						</div>
					</div>
					<>
						{ ( () => {
							if ( accordionAnswerType === 'text' ) {
								return (
									<RichText
										onChange={ onChangeAccordionAnswer }
										className="ask__accordion__panel faq-answer"
										value={ accordionAnswer }
										placeholder={ __(
											'Write Answer',
											'ask-faq'
										) }
										tagName="div"
										allowedFormats={ [] }
									/>
								);
							} else if ( accordionAnswerType === 'audio' ) {
								return (
									<div className="ask__accordion__panel faq-answer">
										<MediaUpload
											onSelect={
												onSelectAudioMediaChange
											}
											allowedTypes={ [ 'audio' ] }
											render={ ( { open } ) => (
												<Button
													onClick={ open }
													style={ {
														fontSize: '16px',
													} }
												>
													<span className="dashicons dashicons-cloud-upload"></span>{ ' ' }
													{ __(
														'Upload Audio',
														'ask-faq'
													) }
												</Button>
											) }
										/>
										{ accordionAudioAnswer === '' ? (
											<>
												{ __(
													'No Audio Uploaded Yet',
													'ask-faq'
												) }
											</>
										) : (
											<audio
												controls
												src={ accordionAudioAnswer }
											></audio>
										) }
									</div>
								);
							} else if ( accordionAnswerType === 'video' ) {
								return (
									<div className="ask__accordion__panel faq-answer">
										<MediaUpload
											onSelect={
												onSelectVideoMediaChange
											}
											allowedTypes={ [ 'video' ] }
											render={ ( { open } ) => (
												<Button
													onClick={ open }
													style={ {
														fontSize: '16px',
													} }
												>
													<span className="dashicons dashicons-cloud-upload"></span>{ ' ' }
													{ __(
														'Upload Video',
														'ask-faq'
													) }
												</Button>
											) }
										/>
										{ accordionVideoAnswer === '' ? (
											<>
												{ __(
													'No Video Uploaded Yet',
													'ask-faq'
												) }
											</>
										) : (
											<video
												width="320"
												height="240"
												controls
											>
												<source
													src={ accordionVideoAnswer }
												/>
											</video>
										) }
									</div>
								);
							}
						} )() }
					</>
				</li>
			) ) }
		</>
	);
}
